import { useState } from 'react';
import { MoveToReviewDialog } from '../MoveToReviewDialog';

type MoveToReviewModalParams = {
  onConfirm: () => void;
};

export const useMoveToReviewModal = () => {
  const [params, setParams] = useState<MoveToReviewModalParams | null>(null);

  const openModal = (modalParams: MoveToReviewModalParams) => {
    setParams(modalParams);
  };

  const handleClose = () => {
    setParams(null);
  };

  const node = (
    <MoveToReviewDialog
      open={params !== null}
      onClose={handleClose}
      onConfirm={() => {
        params?.onConfirm();
        handleClose();
      }}
    />
  );

  return { node, openModal };
};
